export default __webpack_public_path__ + "static/media/loading.149a7823.gif";